import {
  AutoStoriesRounded,
  AssignmentOutlined,
  BuildRounded,
  ProductionQuantityLimitsRounded,
  AutoGraphOutlined,
  CheckRounded,
  ClearAllRounded,
  HandymanOutlined,
  CorporateFareOutlined,
  DashboardOutlined,
  EngineeringOutlined,
  FlightTakeoffOutlined,
  History,
  InboxOutlined,
  SupportAgent,
  FollowTheSigns,
  PeopleOutlineOutlined,
  QueryStats,
  RequestPageOutlined,
  ScheduleRounded,
  Settings,
  SnippetFolderOutlined,
  WorkOutlineOutlined,
  Inventory2Outlined,
  AdminPanelSettings,
  ExitToApp,
  WidgetsRounded,
  QuestionMarkRounded,
  Star,
  DriveFileMove,
  DynamicFeed,
  ExtensionOutlined,
  NextWeekOutlined,
  Link,
  DescriptionOutlined,
} from '@mui/icons-material'
import { SvgIconProps } from '@mui/material/SvgIcon'
import clsx from 'clsx'

export type NavIconVariety =
  // Analytics section
  | 'dashboard'
  | 'reports'
  | 'documentHub'
  // Maintenance section
  | 'dueList'
  | 'maintenanceItems'
  | 'components'
  | 'pastCompliance'
  | 'logbookEntries'
  | 'activityLog'
  | 'purchaseOrders'
  | 'logbookIngestions'
  // Inventory section
  | 'inventory'
  | 'dueInventory'
  | 'tools'
  // Work Orders section
  | 'myWorkOrders'
  | 'scheduled'
  | 'completed'
  | 'externalWorkOrders'
  // Admin section
  | 'users'
  | 'organizations'
  | 'aircraft'
  | 'onboarding'
  | 'aircraftTemplates'
  | 'support'
  | 'features'
  | 'activity'
  | 'references'
  | 'integrations'
  | 'taskLinking'
  | 'selfOnboarding'
  | 'monitoring'
  | 'forms'
  // Other
  | 'inbox'
  | 'adminSettings'
  | 'settings'
  | 'backToApp'

const NavIcon = ({
  variety,
  ...props
}: { variety: NavIconVariety } & SvgIconProps) => {
  switch (variety) {
    // Analytics section
    case 'dashboard':
      return <DashboardOutlined {...props} />
    case 'reports':
      return <AutoGraphOutlined {...props} />
    case 'documentHub':
      return <SnippetFolderOutlined {...props} />
    case 'forms':
      return <DescriptionOutlined {...props} />
    // Maintenance section
    case 'dueList':
      return <ClearAllRounded {...props} />
    case 'components':
      return <WidgetsRounded {...props} />
    case 'maintenanceItems':
      return <HandymanOutlined {...props} />
    case 'pastCompliance':
      return <AssignmentOutlined {...props} />
    case 'logbookEntries':
      return <WorkOutlineOutlined {...props} />
    case 'activityLog':
      return <History {...props} />
    case 'purchaseOrders':
      return <RequestPageOutlined {...props} />
    case 'logbookIngestions':
      return <NextWeekOutlined {...props} />
    // Inventory section
    case 'inventory':
      return <Inventory2Outlined {...props} />
    case 'dueInventory':
      return <ProductionQuantityLimitsRounded {...props} />
    case 'tools':
      return <BuildRounded {...props} />
    // Work Orders section
    case 'myWorkOrders':
      return <EngineeringOutlined {...props} />
    case 'scheduled':
      return <ScheduleRounded {...props} />
    case 'completed':
      return <CheckRounded {...props} />
    case 'externalWorkOrders':
      return <WorkOutlineOutlined {...props} />
    // Admin section
    case 'users':
      return <PeopleOutlineOutlined {...props} />
    case 'organizations':
      return <CorporateFareOutlined {...props} />
    case 'aircraft':
      return <FlightTakeoffOutlined {...props} />
    case 'onboarding':
      return <DriveFileMove {...props} />
    case 'aircraftTemplates':
      return <DynamicFeed {...props} />
    case 'support':
      return <SupportAgent {...props} />
    case 'selfOnboarding':
      return <FollowTheSigns {...props} />
    case 'features':
      return <Star {...props} />
    case 'activity':
      return <QueryStats {...props} />
    case 'references':
      return <AutoStoriesRounded {...props} />
    case 'integrations':
      return <ExtensionOutlined {...props} />
    case 'taskLinking':
      return <Link {...props} />
    case 'monitoring':
      return <QueryStats {...props} />
    // Other
    case 'inbox':
      return <InboxOutlined {...props} />
    case 'adminSettings':
      return <AdminPanelSettings {...props} />
    case 'settings':
      return <Settings {...props} />
    case 'backToApp':
      return (
        <ExitToApp className={clsx('rotate-180', props.className)} {...props} />
      )
    default:
      return <QuestionMarkRounded {...props} />
  }
}

export default NavIcon
